import { Container } from "reactstrap";

const ContributionByCheck = () => {
  return (
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "500px" }}
    >
      <p
        className="text-center"
        style={{ fontWeight: "bold", color: "gray", fontSize: "20px" }}
      >
        Contribution By Check
      </p>
    </Container>
  );
};
export default ContributionByCheck;
